import {
  getCascadeRequiredValues,
  getCascadeValues,
} from "../api/Validations";
import {
  CascadeRequiredValue,
  CascadeValue,
} from "../models/analysiscodes/AnalysisCodes";
import { useWorkOrderStore } from "../store/wo-order";
import { getParentFieldMappings } from "./MetadataHelper";

// Re-exported so the existing importers of this module keep working; defined in MetadataHelper
// so the cascade matching does not have to pull the API layer in with it.
export { getParentFieldMappings };

export const getStoreAccountCascadeValues = async (parentFields: string[]) => {
  //in case offline it will be downloaded and stored inside wo-store
  let cascadeValues: CascadeValue[] | undefined =
    useWorkOrderStore.getState().cascadeValues;
  if (!cascadeValues) {
    const response = await getCascadeValues();
    cascadeValues = response.data;
  }
  let cascadeData: { [key: string]: CascadeValue[] } = {};
  parentFields.forEach((p) => {
    const filteredValues =
      cascadeValues?.filter((validValue) => {
        return getParentFieldMappings(p).some(
          (f) => f.toLowerCase() === validValue.ParentField.toLowerCase()
        );
      }) || [];

    cascadeData = { ...cascadeData, [p]: filteredValues };
  });
  return cascadeData;
};

/**
 * US 906024 - the plant's cascade "required" flags, from the store when they are already there
 * (which is also what makes them work offline) and from the server the first time.
 *
 * An empty list is cached as an empty list, not as "not loaded": a plant with no rules
 * configured is the normal case and must not re-request on every screen open. A failure is
 * cached the same way on purpose - these flags only ADD required-ness, so not having them must
 * never stop a screen from working.
 */
export const getCascadeRequiredValuesForPlant = async () => {
  let requiredValues: CascadeRequiredValue[] | undefined =
    useWorkOrderStore.getState().cascadeRequiredValues;
  if (!requiredValues) {
    try {
      const response = await getCascadeRequiredValues();
      requiredValues =
        !response.isError && Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.log("Unable to get cascade required values", error);
      requiredValues = [];
    }
    useWorkOrderStore.getState().setCascadeRequiredValues(requiredValues);
  }
  return requiredValues;
};
